import React, { RefObject, forwardRef, memo, useRef } from "react";
import '../../styles/components/popover.scss';
import { Portal } from "../portal";

interface PopoverProps {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
}

export const Popover = memo(forwardRef<HTMLDivElement, PopoverProps>(({ children, open, onClose }, ref: RefObject<HTMLDivElement>) => {
  const currentRef = useRef<HTMLDivElement>();
  const parentCoords = ref?.current?.getBoundingClientRect();
  const left = parentCoords?.left
  const top = parentCoords?.top + parentCoords?.height + window.pageYOffset;

  const style = {
    left,
    top,
  };

  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    open && (
      <Portal where={document.getElementById('modalContainer')}>
        <div 
          className="popover-wrapper"
          onClick={onClose}
        >
          <div
            ref={currentRef}
            className="popover"
            style={style}
            onClick={stopPropagation}
          >
            {children}
          </div>
        </div>
      </Portal>
    )
  )
}));